/* Teeshaa: no island words (Oct 2026). Every text block (heading, paragraph, caption, button, list item) keeps at least
   two words on its last line: the space between its last two words becomes a non-breaking space. If that pair would not
   fit the block's width (a large heading on a narrow phone), the change is undone. Runs again on content added later
   (predictive search, Show more, the cart drawer); each block is tried once, and only added nodes are watched, so the
   script's own edits never re-trigger it. Not loaded on the Bespoke page (layout/theme.liquid). */
(function () {
  var NBSP = ' ', SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|CODE|PRE|SVG|IFRAME|TEMPLATE)$/;
  function inlineish(d) { return d === 'inline' || d === 'contents' || d === 'none'; }
  function isBlock(el) {
    if (SKIP.test(el.tagName) || el.isContentEditable) return false;
    var cs = getComputedStyle(el);
    if (inlineish(cs.display) || /^(nowrap|pre)/.test(cs.whiteSpace)) return false;
    return true;
  }
  function lastTextNode(el) {
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = tw.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      var p = n.parentElement; while (p && p !== el) { var dp = getComputedStyle(p).display; if (!inlineish(dp) && dp !== 'inline-block' && dp !== 'inline-flex') return null; p = p.parentElement; } /* has a block child: not a leaf */
      last = n;
    }
    return last;
  }
  function words(el) {             /* every word in reading order: [textNode, start, end] */
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, out = [], m, re;
    while ((n = tw.nextNode())) { re = /[^\s ]+/g; while ((m = re.exec(n.nodeValue))) out.push([n, m.index, m.index + m[0].length]); }
    return out;
  }
  function box(node, el) {          /* the largest wrapper (below el) that holds just this one word */
    var a = node, w = node.nodeValue.trim();
    while (a.parentNode && a.parentNode !== el && a.parentNode.textContent.trim() === w) a = a.parentNode;
    return a;
  }
  function fits(el, w0, undo) {     /* keep the change only if the block does not overflow; try gentle fallbacks first */
    var over = function () { return el.scrollWidth > Math.max(el.clientWidth, w0) + 1; };
    if (!over()) return true;
    var ok = function () { st.removeProperty('transition'); return true; };
    var cs = getComputedStyle(el), fs = parseFloat(cs.fontSize) || 16, par = el.parentElement, st = el.style, saved = st.cssText;
    var set = function (k, v) { st.setProperty(k, v, 'important'); };
    set('transition', 'none');                       /* measure the new size now, not mid-transition */
    if (cs.maxWidth !== 'none') { set('max-width', 'none'); if (!over() && (!par || par.scrollWidth <= par.clientWidth + 1)) return ok(); st.cssText = saved; set('transition', 'none'); }
    if (fs < 18) {                                   /* small text: tighter tracking, then up to 8% smaller */
      set('letter-spacing', Math.min(parseFloat(cs.letterSpacing) || 0, fs * .04) + 'px'); if (!over()) return ok();
      set('font-size', (fs * .92).toFixed(2) + 'px'); if (!over()) return ok();
    } else if (fs >= 24) {                           /* headings: allow up to 25% smaller rather than strand a word */
      if (cs.maxWidth !== 'none') set('max-width', 'none');
      for (var k = .92; k >= .749; k -= .08) { set('font-size', (fs * k).toFixed(2) + 'px'); if (!over() && (!par || par.scrollWidth <= par.clientWidth + 1)) return ok(); }
    }
    st.cssText = saved; undo(); return false;
  }
  function fix(el) {
    if (el.__ni) return;
    el.__ni = true;                                  /* tried once, whatever the outcome */
    if (!isBlock(el)) return;
    if (lastTextNode(el) === null) return;
    var ws = words(el); if (ws.length < 3) return;
    var w0 = el.scrollWidth;
    /* 1. a typed line break that leaves one word alone on the last line: let the line flow instead */
    var brs = el.querySelectorAll('br');
    if (brs.length) {
      var br = brs[brs.length - 1], after = 0;
      ws.forEach(function (w) { if (br.compareDocumentPosition(w[0]) & Node.DOCUMENT_POSITION_FOLLOWING) after++; });
      if (after === 1) { var sp = document.createTextNode(' '); br.parentNode.replaceChild(sp, br); }
    }
    el.normalize(); ws = words(el);
    var a = ws[ws.length - 2], b = ws[ws.length - 1];
    if (a[0] === b[0]) {
      /* 2. both words in one text node: the space between them becomes non-breaking */
      var n = b[0], v = n.nodeValue, gap = v.slice(a[2], b[1]);
      if (!/^[ \t\n\r]+$/.test(gap)) return;
      if (v.slice(b[1], b[2]).length > 18) return;
      n.nodeValue = v.slice(0, a[2]) + NBSP + v.slice(b[1]);
      fits(el, w0, function () { n.nodeValue = v; });
    } else {
      /* 3. words in separate wrappers (e.g. animated headings): the space between the two wrappers becomes non-breaking */
      var x = box(a[0], el), y = box(b[0], el), sep = x.nextSibling;
      if (!sep || sep.nodeType !== 3 || sep.nextSibling !== y || !/^[ \t\n\r]+$/.test(sep.nodeValue)) return;
      var old = sep.nodeValue; sep.nodeValue = NBSP;
      fits(el, w0, function () { sep.nodeValue = old; });
    }
  }
  var TEXTY = /^(H1|H2|H3|H4|H5|H6|P|LI|FIGCAPTION|BLOCKQUOTE|A|BUTTON|LABEL|DT|DD|SUMMARY)$/;
  function run(root) {
    var list = (root || document.body).querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,dt,dd,figcaption,blockquote,label,summary,td,th,a,button,span,div,em,strong');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (!el.firstChild || el.__ni) continue;
      var direct = false;
      for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) { direct = true; break; }
      if (direct || (TEXTY.test(el.tagName) && /\S+\s+\S+\s+\S+/.test(el.textContent))) fix(el);
    }
  }
  function start() {
    var go = function () { if (go.done) return; go.done = true; run(document.body); };
    var loaded = new Promise(function (r) { if (document.readyState === 'complete') r(); else addEventListener('load', r); });
    Promise.all([loaded, document.fonts && document.fonts.ready ? document.fonts.ready : null]).then(function () { setTimeout(go, 150); });
    setTimeout(go, 5000);
    var q = [], t;
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes.forEach(function (a) { if (a.nodeType === 1) q.push(a); else if (a.nodeType === 3 && a.parentElement) { a.parentElement.__ni = false; q.push(a.parentElement); } });
        /* a heading or paragraph whose words were rebuilt (e.g. split for an animation) is checked again */
        var host = m.target.nodeType === 1 ? m.target.closest('h1,h2,h3,h4,h5,h6,p,li,figcaption,blockquote,a,button,label') : null;
        if (host && m.addedNodes.length) { host.__ni = false; q.push(host); }
      });
      if (!q.length) return;
      clearTimeout(t); t = setTimeout(function () { var w = q.splice(0, 400); w.forEach(function (el) { if (el.isConnected) { fix(el); run(el); } }); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
